import React from "react";
import HeadTabel from "./HeadTabel";
import Tbody from "./Tbody";

export default function TabelelReservations({
  data,
  tableRef,
  IdName,
  customClass,
  setinvoices,
}) {
  return (
    <>
      <table
        id={IdName}
        ref={tableRef}
        className="table table-hover  table-striped    "
      >
        <HeadTabel customClass={customClass} />
        <Tbody data={data} setinvoices={setinvoices} />
      </table>
    </>
  );
}
